import { t } from 'i18next';
import { isEmpty, isUndefined } from 'lodash';
import { Virtuoso } from 'react-virtuoso';
import NotificationItem from './NotificationItem';

export default function NotificationTabPanel({ notifications, loadMore }) {
  if (isUndefined(notifications)) {
    return (
      <>
        {Array.from({ length: 5 }).map((_, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: skeleton
          <div key={index} className="flex items-center border-b-[1px] border-separator1 py-[16px]">
            {/* 프로필 이미지 스켈레톤 */}
            <div className="w-[38px] h-[38px] shrink-0">
              <div className="animate-pulse bg-gray-100 dark:bg-gray-800 w-full h-full rounded-full" />
            </div>

            {/* 텍스트 영역 */}
            <div className="flex flex-col pl-[12px] pr-[12px] flex-1 gap-[6px]">
              {/* title 자리 */}
              <div className="animate-pulse bg-gray-100 dark:bg-gray-800 w-[220px] h-[18px] rounded" />
            </div>
          </div>
        ))}
      </>
    );
  }
  if (isEmpty(notifications)) {
    return (
      <div className="flex flex-col items-center gap-[12px] mt-[130px]">
        <img
          src="/assets/icons/graphic-3d/3D.bell.png"
          alt="empty-bell"
          className="w-[68px] h-[85px]"
        />
        <div className="px-[24px] py-[10px] flex flex-col gap-[14px] text-center">
          <p className="text-[17px] font-bold text-text-main-lv2 leading-none">
            {t('notifications.emptyNotificationCase.title')}
          </p>
          <p className="text-[14px] font-medium text-text-main-lv4 leading-tight whitespace-pre-line">
            {t('notifications.emptyNotificationCase.description')}
          </p>
        </div>
      </div>
    );
  }
  return (
    <div>
      <Virtuoso
        useWindowScroll
        overscan={480}
        data={notifications}
        endReached={loadMore}
        style={{ height: '100px' }}
        itemContent={(_, notification) => (
          <div key={notification.notificationId}>
            <NotificationItem key={notification.notificationId} notification={notification} />
          </div>
        )}
      />
    </div>
  );
}
